import { deleteEmpty } from './common.js'
import request, { appendApiUrl } from '@/utils/request'

// 查询当前登录用户最近购买的游戏
export const getUserRecentGame = (country = '') => {
  return request.get(
    {
      url: `/api/user-recent-game-order/query?country=${country}`,
    },
    {
      showErrorToast: true,
      showLoading: false,
    }
  )
}
// 查询当前登录用户会员信息 [API 接口：19.3]
export const getMemberInfo = (country = '') => {
  return request.get(
    {
      url: appendApiUrl(`/vip/info?country=${country}`),
    },
    {
      showErrorToast: true,
    }
  )
}

// 设置会员生日 [API 接口：19.1]
export const setMemberBirthday = (options) => {
  return request.postJson(
    {
      url: appendApiUrl('/vip/birthday'),
      data: { ...deleteEmpty(options) },
    },
    {
      showErrorToast: true,
    }
  )
}

// 查询会员配置及奖品 [API 接口：19.2]
export const getMemberConfig = (country) => {
  return request.get(
    {
      url: appendApiUrl(`/vip/config?country=${country}`),
    },
    {
      showErrorToast: true,
    }
  )
}

// 获取用户的弹窗消息,并置为已读
export const getMemberWindow = (kicoinId) => {
  return request.get(
    {
      url: appendApiUrl(`/user-message/window?kicoinId=${kicoinId}`),
    },
    {
      showErrorToast: true,
    }
  )
  // console.log('kicoinId', kicoinId)
  // return Promise.resolve([
  //   {
  //     id: '1641043',
  //     kicoinId: '1010252',
  //     userName: '',
  //     country: 'id',
  //     currency: 'Rp',
  //     messageId: '0',
  //     messageShow: 1,
  //     messageRead: 1,
  //     taskStatus: 3,
  //     taskBeginTime: '1675326073',
  //     taskEndTime: '1677918073',
  //     createTime: '1675326073',
  //     updateTime: '1675326073',
  //     visible: true,
  //     messageType: 3,
  //     messageTitle: '弹窗消息',
  //     messageBody: '{"type":2,"content":"280000","levelCode":9}',
  //   },
  //   {
  //     id: '1641044',
  //     kicoinId: '1010252',
  //     userName: '',
  //     country: 'id',
  //     currency: 'Rp',
  //     messageId: '0',
  //     messageShow: 1,
  //     messageRead: 1,
  //     taskStatus: 3,
  //     taskBeginTime: '1675326075',
  //     taskEndTime: '1677918075',
  //     createTime: '1675326075',
  //     updateTime: '1675326075',
  //     visible: true,
  //     messageType: 3,
  //     messageTitle: '弹窗消息',
  //     messageBody: '{"type":1,"content":"619342943","levelCode":9}',
  //     // '{"type":1,"content":"619342943,619342940,619342941","levelCode":9}',
  //   },
  // ])
}

// 获取用户的弹窗消息,并置为已读
export const getConsumptionValues = (region) => {
  return request.get(
    {
      url: appendApiUrl(`/vip/bonus/config?country=${region}`),
    },
    {
      showErrorToast: true,
    }
  )
}
